export default __webpack_public_path__ + "static/media/quantum-computer.f7fe321a.jpeg";